
import {
  SET_FOLDER_ID_FOR_NEW_PAGE
} from '../const/action_types.js';


export default (state = {}, action)=> {

  switch (action.type) {

  case SET_FOLDER_ID_FOR_NEW_PAGE:
    return {
      ...state,
      folderId: action.folderId
    };

  default:
    return state;
  }
};

export const getFolderIdForNewPage = (state)=>
  state.folderId;